import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { Page } from "../../../helbest";
import CreateCar from "./CreateCar";
import EditCar from "./EditCar";
import CarItem from "./CarItem";
import { connect } from "react-redux";

import { API } from "../../../request/api";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";

import { ReactComponent as IconPlus } from "../../../assets/svg/plus.svg";
import { ReactComponent as EmptyBoxIcon } from "../../../assets/svg/empty-box.svg";
import Button from "../../components/ui/Button";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
const MyCars = (props) => {
  const [new_car, set_new_car] = useState(false);
  const [delete_car, set_delete_car] = useState(false);
  const [edit_car, set_edit_car] = useState(false);
  const [my_cars, set_my_cars] = useState([]);
  const [selected_car, set_selected_car] = useState(null);
  const [user_car_id, set_user_car_id] = useState(null);
  const navigate = useLangNavigate();

  const GET_USER_CARS = () => {
    API.get
      .userCars()
      .then((response) => {
        set_my_cars(response.data);
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  // const addCar = (car) => {
  //   set_my_cars([...my_cars, car])
  // };

  const updateMyCar = (update_car) => {
    let my_cars_list = my_cars.map((car) => {
      if (car.user_car_id === update_car.user_car_id) {
        return update_car;
      } else {
        return car;
      }
    });
    set_my_cars(my_cars_list);
  };

  const deleteCar = () => {
    API.del
      .userCar(user_car_id)
      .then((response) => {
        set_delete_car(false);
        set_my_cars(response.data);
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  const deleteModalCar = (user_car_id) => {
    set_user_car_id(user_car_id);
    set_delete_car(true);
  };

  const editModalCar = (user_car_id) => {
    let selected_car = my_cars.find((car) => car.user_car_id === user_car_id);
    set_user_car_id(user_car_id);
    set_edit_car(true);
    set_selected_car(selected_car);
  };

  const check_user = () => {
    if (!props.Login.is_login) {
      navigate("/login/d/");
    }
  };

  useEffect(() => {
    GET_USER_CARS();
  }, []); // eslint-disable-line

  useEffect(() => {
    check_user();
  }, [props.Login]); // eslint-disable-line

  return (
    <Page
      className="page-cars"
      customHeader={<HeaderBack title="My Cars" />}
      back={true}
      address="/"
      showFooter
    >
      <div className="container desktop-mode">
        <div className="flex column car_items">
          {my_cars.length === 0 && (
            <div className="empty-cars-list">
              <EmptyBoxIcon />
              <span>No cars found</span>
            </div>
          )}
          {my_cars.length > 0 &&
            my_cars.map((car, i) => {
              return (
                <CarItem
                  deleteModalCar={deleteModalCar}
                  editModalCar={editModalCar}
                  car={car}
                  key={i}
                />
              );
            })}
        </div>
        <div className="container text-center">
          <Button
            style_width="100%"
            className="btn-new-car"
            onClick={() => set_new_car(true)}
          >
            <IconPlus className="hei-15 mr-2" />
            Add a new car
          </Button>
        </div>
      </div>
      <CreateCar
        closeModal={() => set_new_car(false)}
        addCar={(car) => set_my_cars([...my_cars, car])}
        edit={false}
        new_car={new_car}
      />
      <EditCar
        closeModal={() => set_edit_car(false)}
        updateMyCar={updateMyCar}
        car={selected_car}
        edit={true}
        edit_car={edit_car}
      />
      <Modal
        className="cars-delete-modal"
        centered={true}
        closeIcon={<span></span>}
        title=""
        open={delete_car}
        footer={false}
        closable={true}
      >
        <div className="flex column text-center">
          <label>Are you sure you want to delete this car?</label>
          <div className="w-full flex justify-between items-center mt-4">
            <Button
              style_width="49%"
              style_backgroundColor="type-error"
              style_fontSize="type-2"
              onClick={() => set_delete_car(false)}
            >
              No
            </Button>
            <Button
              style_width="49%"
              style_fontSize="type-2"
              onClick={deleteCar}
              // className="btn-h40 btn background-main21 text-white btn-45 mt10 line-none font-14 ml-1 delete-btn"
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </Page>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(MyCars);
